import styles from "./user-role-management.module.css";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Empty, Row, Spin, Typography } from "antd/es";
import CustomTextfield from "../../common/input/custom-textfield/custom-textfield";
import SVGIcon from "../../constants/SVGIcon";
import CustomButton from "../../common/custom-button/custom-button";
import AddEditUserRole from "./components/add-edit-user-role/add-edit-user-role";
import UserRole from "./components/user-role/user-role";
import {
  deleteUserRole,
  getAllSuperAdmins,
} from "../../services/user_role_management";

import { toast } from "react-toastify";

const UserRoleManagement = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [superAdminList, setSuperAdminList] = useState([]);
  const [userRoleData, setUserRoleData] = useState({});

  useEffect(() => {
    const timeOut = setTimeout(() => {
      getSuperAdminList();
    }, 500);
    return () => {
      clearTimeout(timeOut);
    };
  }, [searchTerm]);

  const getSuperAdminList = async () => {
    try {
      setLoading(true);
      const payload = {};
      if (searchTerm) {
        payload.search = searchTerm;
      }
      const response = await getAllSuperAdmins(payload);
      if (response?.status) {
        const tempList = response?.data?.data?.superAdmins?.map((item) => ({
          ...item,
          privileges: item?.privileges ? JSON.parse(item?.privileges) : [],
        }));
        setSuperAdminList(tempList);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const handleDelete = async (data) => {
    setLoading(true);
    try {
      const response = await deleteUserRole(data?.id);
      if (response.status) {
        toast.success("User role deleted successfully");
        setLoading(false);
        getSuperAdminList();
      }
    } catch (error) {
      toast.error(error?.data?.message);
      console.error("error", error?.data?.message);
      setLoading(false);
    }
  };

  const handleAddNew = () => {
    setOpenDrawer(true);
  };

  const handleEdit = (data) => {
    setOpenDrawer(true);
    setUserRoleData(data);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    setUserRoleData({});
    getSuperAdminList();
  };

  return (
    <div className={styles.user_role_management}>
      <div className={styles.headerContainer}>
        <Typography className={styles.title}>User Role Management</Typography>
        <div className={styles.filterContainer}>
          <CustomTextfield
            id={"search"}
            type={"text"}
            className={styles.inputField}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e?.target?.value)}
            prefix={
              <SVGIcon
                name={"search-icon"}
                width={"24"}
                height={"24"}
                className="anticon"
                stroke={"#667085"}
              />
            }
            placeholder={"Search"}
          />
          <CustomButton
            title="Add User Role"
            size={"large"}
            icon={
              <SVGIcon
                name={"add-icon"}
                width={"24"}
                height={"24"}
                className="anticon"
                stroke={"#FFF"}
              />
            }
            className={styles.add_user_role_button}
            onClick={handleAddNew}
          />
        </div>
      </div>
      <div className={styles.user_role_list}>
        <Spin spinning={loading}>
          <div className={styles.cardGrid}>
            {superAdminList?.map((item, index) => (
              <div className={styles.cardItem} key={index}>
                <UserRole
                  key={index}
                  data={item}
                  onDelete={handleDelete}
                  onEdit={handleEdit}
                />
              </div>
            ))}
          </div>
        </Spin>
      </div>
      {openDrawer && (
        <AddEditUserRole
          userRoleData={userRoleData}
          open={openDrawer}
          onClose={handleCloseDrawer}
        />
      )}
    </div>
  );
};

export default UserRoleManagement;
